import Navbar from "./Navbar";
import { Grid, Toolbar, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import whatsapplogo from "./resource/WhatsAppButtonGreenSmall.svg";
import Footer from "./Footer";
import backgroundClass from "./resource/orchestral8darken.jpg";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";

import EventData from "./EventPosts";

function Events() {
    const backGroundBlur = {
            backgroundImage: `url(${backgroundClass})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          };

  return (
    <div style={backGroundBlur}> 
    <Grid
      container
      direction="column"
      sx={{
        minHeight: "100vh",
        overflowX: "hidden", // ✅ prevent horizontal scroll
      }}
    >
      {/* Navbar */}
      <Grid item sx={{ width: "100%" }}>
        <Toolbar>
          <Navbar />
        </Toolbar>
      </Grid>

      {/* Main Content */}
      <Grid item sx={{ flexGrow: 1, width: "100%" }}>
  <p className="normalPHead" style={{ textAlign: "center", color:"white"}}>EVENTS 🎸🎤🎶</p>
      <Grid item>
      <p style={{textAlign:"center", fontSize:"40px", color:"white"}}>“Feel the joy of live orchestral music in a relaxed, community-friendly atmosphere.”</p>
      <p style={{textAlign:"center", fontSize:"25px", color:"white"}}>From young musicians to seasoned players, come enjoy an orchestra performance made for everyone!</p>
    </Grid>

        <Grid
          container
          justifyContent="center"
          spacing={3}
          sx={{
            px: 2, // padding instead of margin overflow
            maxWidth: "100%",
          }}
        >
          {EventData.map((event) => (
            <Grid
              item
              key={event.id}
              xs={12}
              sm={6}
              md={4}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                sx={{
                  width: "100%",
                  maxWidth: 345, // ✅ responsive
                  height: 360,
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#282424",   // ✅ black background
                  color: "#fff",             // ✅ default text white
                  
                }}
              >
                <CardActionArea
                  component={Link}
                  to={`/events/${event.id}`}
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                  }}
                >
                  <CardMedia
                    component="img"
                    image={event.image}
                    alt={event.title}
                    sx={{
                      height: 140,
                      width: "100%",
                      objectFit: "cover",
                      flexShrink: 0,
                    }}
                  />

                  <CardContent sx={{ flexGrow: 1, overflow: "hidden" }}>
                    <Typography
                      gutterBottom
                      variant="h5"
                      sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      <p>{event.title}</p>
                    </Typography>

                    <Typography
                      variant="body2"
                      color="white"
                      sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      <p>{event.content}</p>
                      <p>{event.price}</p>
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Footer */}
      <Grid item sx={{ width: "100%" }}>
        <Footer />
      </Grid>

      {/* WhatsApp Floating Button */}
      <a
        aria-label="Chat on WhatsApp"
        href="https://wa.me/+6591124691?text=Hi%2C%20I%20would%20like%20to%20find%20out%20more%20about%20the%20courses%20%20offered%20by%20Quindicesima%21"
      >
              <img
              alt="Chat on WhatsApp"
              src={whatsapplogo}
              style={{ position: "fixed", bottom: 5, right: 5 }}
            />
      </a>
    </Grid>
    </div>
  );
}

export default Events;
